<template>
  <s-modal
    v-model="showModal"
    ok-only
    centered
    scrollable
    size="xl"
    :title="title"
    @show="show()"
    @ok="onConfirm"
  >
    <div v-if="hasItems">
      <b-container
        class="suppressed-items__accordion p-0 mb-3"
        fluid
      >
        <b-row
          class="suppressed-items__accordion-items"
          align-h="end"
          no-gutters
        >
          <accordion-list
            :modules="items"
            :show-checkboxes="false"
          />
        </b-row>
      </b-container>
      <grid-paginator
        v-model="currentPage"
        class="modal-paginator"
        :total-rows="totalItens"
        :per-page="perPage"
        @input="paging()"
      />
    </div>
    <b-container
      v-else
      fluid
    >
      <s-empty-list />
    </b-container>
  </s-modal>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import GridPaginator from '@/components/lists/Paginator';
import AccordionList from '../AccordionList';

export default {
  name: 'SelectedAlarmsModal',
  components: {
    GridPaginator,
    AccordionList,
  },
  props: {
    value: {
      type: Boolean,
    },
    selectedAlarms: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    items: [],
    currentPage: 1,
    totalItems: 0,
    perPage: 15,
  }),
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    hasItems() {
      return !!(this.items || []).length;
    },
    paginateFirstIndex() {
      return (this.currentPage - 1) * this.perPage;
    },
    paginateLastIndex() {
      return (this.currentPage * this.perPage);
    },
    totalItens() {
      return (this.selectedAlarms || []).length;
    },
    title() {
      return this.$t('alarm-configurations.query.selected-alarms');
    },
  },
  methods: {
    getPaginatedItems() {
      const paginatedItems = (this.selectedAlarms || [])
        .slice(this.paginateFirstIndex, this.paginateLastIndex);
      return this.mergeArrays(paginatedItems);
    },
    setAccordionContentToTop() {
      const element = document.getElementsByClassName('suppressed-items__accordion')[0];

      if (element) {
        element.scrollTop = 0;
      }
    },
    paging() {
      this.items = this.getPaginatedItems();
      this.setAccordionContentToTop();
    },
    show() {
      this.items = [];
      this.currentPage = 1;
      this.totalItems = 0;
      this.paging();
    },
    onConfirm() {
      this.showModal = false;
    },
    mergeArrays(...arraysList) {
      const arrays = cloneDeep(arraysList);
      let jointArray = [];

      arrays.forEach((array) => {
        jointArray = [...jointArray, ...array];
      });

      return jointArray.reduce((newArray, item) => {
        const index = newArray.findIndex(newItem => newItem.moduleId === item.moduleId);

        if (index >= 0) {
          newArray[index].alarms.push(...item.alarms);
          return newArray;
        }

        return [...newArray, item];
      }, []);
    },
  },
};
</script>

<style lang="sass" scoped>
  .modal-body
    padding-top: 0 !important
    & .suppressed-items
      &__remove-all
        color: var(--font-color-primary)
        min-width: 30px !important
        min-height: 20px !important
        font-size: .9em
        &:hover
          color: var(--color-page-background)
      &__accordion ::v-deep
        width: 100%
        height: 55vh
        margin-top: 5px
        overflow-y: auto
        overflow-x: auto
      &__accordion-items
        min-width: 820px
    & .modal-paginator
      ::v-deep .paginator
        &__summary-label
          padding-left: 0
</style>
